module.exports = __webpack_public_path__ + "static/media/gomma.61d9487c.mp3";